// @flow

import { type Field } from '../Field/FieldType';
import * as TYPES from './fieldType';

const TASK_COUNT: Field = {
  displayName: 'Task Count',
  fieldName: 'run.taskCount',
  type: TYPES.FIELD_TYPE_NUMBER
};

const RUN_OWNER_EMAIL: Field = {
  displayName: 'Run Owner Email',
  fieldName: 'run.owner.email',
  type: TYPES.FIELD_TYPE_STRING
};

const RUN_OWNER_FULLNAME: Field = {
  displayName: 'Run Owner Full Name',
  fieldName: 'run.owner.fullName',
  type: TYPES.FIELD_TYPE_STRING
};

const RUN_START_DATE: Field = {
  displayName: 'Run Start Date',
  fieldName: 'run.startDate',
  type: TYPES.FIELD_TYPE_DATE
};

const RUN_PERCENT_COMPLETE: Field = {
  displayName: 'Run Percent Complete',
  fieldName: 'run.percentComplete',
  type: TYPES.FIELD_TYPE_NUMBER
};

const RUN_COMPLETED_COUNT: Field = {
  displayName: 'Completed Task Count',
  fieldName: 'run.completedCount',
  type: TYPES.FIELD_TYPE_NUMBER
};

const RUN_IS_OVERDUE: Field = {
  displayName: 'Run is Overdue',
  fieldName: 'run.isOverdue',
  type: TYPES.FIELD_TYPE_BOOL
};

const IMPLICIT_RUN_FIELDS: Array<Field> = [
  TASK_COUNT,
  RUN_OWNER_EMAIL,
  RUN_OWNER_FULLNAME,
  RUN_START_DATE,
  RUN_PERCENT_COMPLETE,
  RUN_COMPLETED_COUNT,
  RUN_IS_OVERDUE
];

export default IMPLICIT_RUN_FIELDS;



// WEBPACK FOOTER //
// ./js/const/implicitRunFields.js